import React from 'react';
import cn from 'classnames';

import { ProgramRuleEntity, RequirementEntity } from 'Models/Entities';

interface IOrConditionLabelProps {
	className?: string;
	childRequirements: (RequirementEntity | ProgramRuleEntity)[],
	visible?: boolean;
}

const OrConditionLabel = ({
	className,
	childRequirements,
	visible = true,
}: IOrConditionLabelProps) => {
	if (!visible) {
		return null;
	}

	return (
		<div
			className={cn(
				'condition-label',
				className,
			)}
		>
			<span className="txt-bold" key="select-one">Select One: </span>
			{
				childRequirements
					.map((requirement, index) => {
						return index
							? (
								[
									<span
										key={`condition-label-${requirement.id}`}
										className="txt-bold"
									>
										{' OR '}
									</span>,
									requirement.displayName,
								]
							)
							: requirement.displayName;
					})
			}
		</div>
	);
};

export default OrConditionLabel;
